import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';

// project imports
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Loader from 'components/Loader';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { DRAWER_COMPACT_MAX_WIDTH } from 'config';

// ==============================|| MAIN LAYOUT ||============================== //

export default function DashboardLayout() {
  const { menuMasterLoading } = useGetMenuMaster();
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const compactDesktop = useMediaQuery(`(max-width:${DRAWER_COMPACT_MAX_WIDTH}px)`);

  useEffect(() => {
    if (downLG) {
      handlerDrawerOpen(false);
      return;
    }
    handlerDrawerOpen(!compactDesktop);
  }, [compactDesktop, downLG]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        maxWidth: '100%',
        minHeight: '100vh',
        overflowX: 'hidden',
        boxSizing: 'border-box'
      }}
    >
      <Drawer />
      <Header />

      <Box
        component="main"
        sx={{
          flex: 1,
          minWidth: 0,
          maxWidth: '100%',
          position: 'relative',
          zIndex: 0,
          overflowX: 'hidden',
          p: { xs: 2, sm: 3 },
          pt: { xs: 10, sm: 11 }
        }}
      >
        <Box
          sx={{
            ...{ px: { xs: 0, sm: 2 } },
            position: 'relative',
            minHeight: 'calc(100vh - 64px)',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Outlet />
          <Footer />
        </Box>
      </Box>
    </Box>
  );
}
